/**------------- Used Car Drawer Info Panel constants -------------**/

/*  CTA Button  */
export const USED_CAR_DRAWER_CTA_BUTTON_TEXT =
	"Verifica disponibilità";
